import React from "react";
import { useTranslation } from "react-i18next";
import {
  FormControl,
  Select,
  MenuItem,
  Box,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import MDBox from "components/MDBox";

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;
    i18n.changeLanguage(selectedLanguage);

    // Update document direction based on language
    document.documentElement.dir = selectedLanguage === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = selectedLanguage;
  };

  const languages = [
    { code: "en", name: "English", flag: "🇺🇸" },
    { code: "ar", name: "العربية", flag: "🇸🇦" },
  ];

  // The browser detector can report a regional tag ("en-US", "ar-SA"). The
  // Select only has "en"/"ar" options, so an unnormalized value matched
  // nothing and the switcher rendered as an empty box.
  const currentLanguage = (i18n.language || "en").split("-")[0];

  return (
    <MDBox display="flex" alignItems="center" gap={1}>
      <LanguageIcon sx={{ color: "text.secondary", fontSize: 24 }} />
      <FormControl size="small" sx={{ minWidth: 80 }}>
        <Select
          value={currentLanguage}
          onChange={handleLanguageChange}
          sx={{
            // The navbar is light; the old forced-white text made the control
            // invisible (white on white).
            color: "text.primary",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(0, 0, 0, 0.2)",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(0, 0, 0, 0.4)",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "info.main",
            },
            "& .MuiSvgIcon-root": {
              color: "text.secondary",
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                bgcolor: "background.paper",
                "& .MuiMenuItem-root": {
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                },
              },
            },
          }}
        >
          {languages.map((lang) => (
            <MenuItem key={lang.code} value={lang.code}>
              <Box component="span" sx={{ fontSize: "1.44rem", mr: 1 }}>
                {lang.flag}
              </Box>
              <Typography variant="body2">{lang.name}</Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </MDBox>
  );
};

export default LanguageSwitcher;
